// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.7157 2.3082C17.1162 1.70869 16.0895 2.08042 16.0127 2.92477L15.7069 6.28926L14.6246 5.20695C13.453 4.03538 11.5535 4.03538 10.3819 5.20695L8.50277 7.08612L16.917 15.5003L18.7962 13.6212C19.9677 12.4496 19.9677 10.5501 18.7962 9.37853L17.7153 8.29766L21.0798 7.9918C21.9241 7.91504 22.2959 6.88831 21.6963 6.2888L17.7157 2.3082Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.306 17.7179C1.70649 17.1184 2.07822 16.0917 2.92257 16.0149L6.2963 15.7082L8.2963 17.7082L7.9896 21.082C7.91284 21.9263 6.88611 22.298 6.2866 21.6985L2.306 17.7179Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.5028 16.9145L13.6246 18.7927C12.453 19.9643 10.5535 19.9643 9.38194 18.7927L5.21036 14.6212C4.03879 13.4496 4.03879 11.5501 5.21037 10.3785L7.08856 8.50033L15.5028 16.9145Z"}}]};

const CandyFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'candy-filled',
    ref,
    icon: element,
  },
));

CandyFilledIcon.displayName = 'CandyFilledIcon';

export default CandyFilledIcon;
